import { createStore, Store } from 'redux';
import { RootState } from 'src/types/RootState';

export function getReportFakeStore(state: RootState): Store<RootState> {
  return createStore(() => state);
}
